/* irh-recipe.js: the iSpice recipe page (2026-10-13).
   Ingredient checklist with servings scaling, tap-to-finish steps with real timers, a full-screen cook mode
   that keeps the screen awake, the video loaded only when asked for, "add the spices to cart", and
   "more like this" from the recipe library. Every feature degrades to the plain printed recipe. */
(function () {
  'use strict';
  var root = document.querySelector('[data-irh-recipe]');
  if (!root || !window.IRH) return;
  var X = window.IRH, esc = X.esc;
  var $ = function (s, el) { return (el || root).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || root).querySelectorAll(s)); };
  var HANDLE = root.getAttribute('data-handle') || location.pathname;
  var KEY = 'irh-cook-' + HANDLE;

  /* ---------------- 1. text recipes: lift the ingredient list and the steps out of the article ---------------- */
  var body = $('[data-irh-body]');
  if (body && !$$('#irh-checks .irh-check').length) liftFromBody(body);
  function liftFromBody(b) {
    /* recipes pasted from a chat tool arrive wrapped in several <div>s: read the real blocks
       (headings, paragraphs, lists) wherever they sit, but never a list nested inside a list item */
    var nodes = Array.prototype.filter.call(b.querySelectorAll('h1,h2,h3,h4,h5,h6,p,ul,ol'), function (el) {
      return !el.parentElement.closest('li,p') && !(el.tagName === 'P' && el.closest('li'));
    }), mode = null, ing = [], steps = [], used = [], intro = [], seenRecipe = false;
    statsFromText(b.innerText || b.textContent);
    /* only the outer list items: a step like "Sear the meatballs:" with its own sub-list is ONE step */
    function topLis(el) {
      var lists = /^(UL|OL)$/.test(el.tagName) ? [el] : Array.prototype.filter.call(el.querySelectorAll('ul,ol'), function (l) { return !l.parentElement.closest('li'); });
      var out = [];
      lists.forEach(function (l) { Array.prototype.forEach.call(l.children, function (c) { if (c.tagName === 'LI') out.push(c); }); });
      return out;
    }
    function heading(el) { return /^(H[1-6])$/.test(el.tagName) || (el.tagName === 'P' && el.children.length === 1 && /^(STRONG|B)$/.test(el.firstElementChild.tagName) && el.textContent.trim().length < 50); }
    nodes.forEach(function (el) {
      var txt = el.textContent.replace(/\s+/g, ' ').trim(), low = txt.toLowerCase();
      if (!txt) return;
      if (!seenRecipe && el.tagName === 'P' && !heading(el)) { intro.push(el); return; }   /* the lines before "Ingredients" are the introduction */
      if (heading(el)) {
        if (/^(tips?|notes?|variations?|serving suggestions?|storage|chef'?s? tips?|tips for)\b/.test(low)) { mode = 'tips'; return; }   /* tips stay as text, they are not steps */
        if (/^ingredients?\b/.test(low)) { mode = 'ing'; seenRecipe = true; used.push(el); return; }
        if (/^(instructions?|directions?|method|steps?|preparation|how to (make|cook))\b/.test(low)) { mode = 'step'; used.push(el); return; }
        if (mode === 'ing' && /:$/.test(txt) && txt.length < 60) { ing.push({ head: txt }); used.push(el); return; }
        if (mode === 'step' && /:$/.test(txt) && txt.length < 60) { used.push(el); return; }
        mode = null; return;
      }
      if (mode === 'ing') {
        var lis = topLis(el);
        if (lis.length) { lis.forEach(function (li) { ing.push({ t: (li.innerText || li.textContent).replace(/\s+/g, ' ').trim() }); }); used.push(el); }
        else if (txt.length < 160) { ing.push(/:$/.test(txt) ? { head: txt } : { t: txt }); used.push(el); }
        else mode = null;
      } else if (mode === 'step') {
        var sl = topLis(el);
        if (sl.length) { sl.forEach(function (li) { steps.push((li.innerText || li.textContent).replace(/\s+/g, ' ').trim()); }); used.push(el); }
        else if (el.tagName === 'P') { steps.push(txt.replace(/^(step\s*)?\d+[.):]\s*/i, '')); used.push(el); }
      }
    });
    if (ing.filter(function (x) { return x.t; }).length < 2) return;   /* not a recognisable recipe: leave the text as it is */
    $('#irh-checks').innerHTML = ing.map(function (x) {
      return x.head ? '<li><h3 style="font-size:14px;letter-spacing:.08em;text-transform:uppercase;color:var(--green);margin:14px 0 4px">' + esc(x.head) + '</h3></li>'
        : '<li><button class="irh-check" type="button" role="checkbox" aria-checked="false" data-line="' + esc(x.t) + '"><i></i><span>' + esc(x.t) + '</span></button></li>';
    }).join('');
    $('#irh-ingr').hidden = false;
    syncRecipeSchema(ing, steps);
    if (steps.length) {
      var ol = $('#irh-steps');
      ol.innerHTML = steps.filter(Boolean).map(function (s, i) { return '<li><button class="irh-step" type="button" role="checkbox" aria-checked="false"><i>' + (i + 1) + '</i><span>' + esc(s) + '</span></button></li>'; }).join('');
      ol.hidden = false;
      $('#irh-steps-h').textContent = 'Method';
      $('#irh-step-count').textContent = steps.length + ' steps';
    }
    used.forEach(function (el) { el.remove(); });
    /* the introduction goes on top of the method, the tips and notes stay underneath */
    if (intro.length) {
      var top = document.createElement('div'); top.className = 'irh-notes irh-intro-text';
      intro.forEach(function (el) { top.appendChild(el); });
      var box = $('#irh-method'), anchor = $('.irh-progress', box) || $('#irh-steps');
      box.insertBefore(top, anchor);
    }
    /* whatever is left (intro, tips, notes) stays below the steps */
    if (!b.textContent.trim()) b.remove();
  }

  function syncRecipeSchema(ingredients, instructions) {
    var title = $('h1');
    if (!title) return;
    var lines = ingredients.map(function (item) { return item.t; }).filter(Boolean);
    var method = instructions.filter(Boolean);
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function (node) {
      var recipe;
      try { recipe = JSON.parse(node.textContent); } catch (error) { return; }
      if (recipe['@type'] !== 'Recipe' || recipe.name !== title.textContent.trim()) return;
      if (!recipe.recipeIngredient || !recipe.recipeIngredient.length) {
        recipe.recipeIngredient = lines;
      }
      if ((!recipe.recipeInstructions || !recipe.recipeInstructions.length) && method.length) {
        recipe.recipeInstructions = method.map(function (text) {
          return { '@type': 'HowToStep', text: text };
        });
      }
      node.textContent = JSON.stringify(recipe);
    });
  }

  /* "Prep Time: 15 minutes · Cook Time: 1 hour · Serves 4" written in the text fills the empty stat tiles */
  function statsFromText(t) {
    var tiles = $$('.irh-rstat'); if (tiles.length < 4) return;
    function grab(re) { var m = t.match(re); return m ? X.mins(m[1]) : null; }
    var p = grab(/prep(?:aration)?\s*time\s*[:\-]?\s*([\d.½]+\s*(?:h(?:ours?|rs?)?|m(?:in(?:ute)?s?)?)(?:\s*\d+\s*m(?:in(?:ute)?s?)?)?)/i);
    var c = grab(/cook(?:ing)?\s*time\s*[:\-]?\s*([\d.½]+\s*(?:h(?:ours?|rs?)?|m(?:in(?:ute)?s?)?)(?:\s*\d+\s*m(?:in(?:ute)?s?)?)?)/i);
    var sv = t.match(/(?:serves|servings|yield)\s*[:\-]?\s*(\d{1,2})/i);
    function set(i, v) { var b = tiles[i].querySelector('b'); if (b && b.textContent.trim() === '–' && v) b.textContent = v; }
    if (p != null) set(0, X.fmt(p));
    if (c != null) set(1, X.fmt(c));
    if (p != null && c != null) set(2, X.fmt(p + c));
    if (sv) { set(3, sv[1]); if (!+root.getAttribute('data-serv')) root.setAttribute('data-serv', sv[1]); }
  }

  /* ---------------- 2. quantities: highlight and scale ---------------- */
  var FR = { '½': .5, '¼': .25, '¾': .75, '⅓': 1 / 3, '⅔': 2 / 3, '⅛': .125 };
  var NUM = '(?:\\d+\\s+\\d+\\/\\d+|\\d+\\/\\d+|\\d+(?:\\.\\d+)?\\s*[½¼¾⅓⅔⅛]|\\d+(?:\\.\\d+)?|[½¼¾⅓⅔⅛])';
  var QRE = new RegExp('^(\\s*)(' + NUM + ')(\\s*(?:-|–|to)\\s*(' + NUM + '))?');
  function toNum(s) {
    s = String(s).trim();
    var m = s.match(/^(\d+(?:\.\d+)?)\s*([½¼¾⅓⅔⅛])$/); if (m) return +m[1] + FR[m[2]];
    if (FR[s] != null) return FR[s];
    m = s.match(/^(\d+)\s+(\d+)\/(\d+)$/); if (m) return +m[1] + m[2] / m[3];
    m = s.match(/^(\d+)\/(\d+)$/); if (m) return m[1] / m[2];
    return parseFloat(s);
  }
  function fmtQ(n) {
    if (n >= 10) return String(Math.round(n));
    var w = Math.floor(n), f = n - w, best = 0, glyph = '', bd = 1;
    [[0, ''], [.125, '⅛'], [.25, '¼'], [1 / 3, '⅓'], [.5, '½'], [2 / 3, '⅔'], [.75, '¾'], [1, '']].forEach(function (c) { var d = Math.abs(f - c[0]); if (d < bd) { bd = d; best = c[0]; glyph = c[1]; } });
    if (bd > .07) return String(Math.round(n * 10) / 10);
    if (best === 1) { w++; glyph = ''; }
    return (w ? String(w) : '') + glyph || '0';
  }
  var lines = $$('#irh-checks .irh-check');
  lines.forEach(function (btn) {
    var span = btn.querySelector('span'), t = span.textContent, m = t.match(QRE);
    if (!m) return;
    var a = toNum(m[2]), b = m[4] ? toNum(m[4]) : null;
    if (!isFinite(a)) return;
    span.innerHTML = esc(m[1]) + '<b data-q="' + a + '"' + (b != null ? ' data-q2="' + b + '"' : '') + '>' + esc(m[2] + (m[3] || '')) + '</b>' + esc(t.slice(m[0].length));
  });
  var base = parseInt(root.getAttribute('data-serv'), 10) || 0, servings = base, factor = 1;
  var MULT = [.5, 1, 1.5, 2, 3, 4], mi = 1;
  function scale() {
    $$('b[data-q]').forEach(function (b) {
      var a = +b.getAttribute('data-q') * factor, q2 = b.getAttribute('data-q2');
      b.textContent = fmtQ(a) + (q2 != null ? '–' + fmtQ(+q2 * factor) : '');
    });
    $('#irh-serv-out').textContent = base ? servings + (servings === 1 ? ' serving' : ' servings') : (MULT[mi] === 1 ? '1×' : fmtQ(MULT[mi]) + '×');
  }
  $$('.irh-serv [data-serv]').forEach(function (b) {   /* not the root, which carries data-serv too */
    b.addEventListener('click', function () {
      var d = +b.getAttribute('data-serv');
      if (base) { servings = Math.max(1, Math.min(base * 6, servings + d)); factor = servings / base; }
      else { mi = Math.max(0, Math.min(MULT.length - 1, mi + d)); factor = MULT[mi]; }
      scale();
    });
  });

  /* ---------------- 3. checklist + steps (remembered for 12 hours) ---------------- */
  var state = X.store(KEY);
  if (!state || Date.now() - state.at > 12 * 3600e3) state = { at: Date.now(), i: [], s: [] };
  function save() { state.at = Date.now(); X.store(KEY, state); }
  $$('#irh-checks .irh-check').forEach(function (b, i) {
    if (state.i.indexOf(i) > -1) b.setAttribute('aria-checked', 'true');
    b.addEventListener('click', function () {
      var on = b.getAttribute('aria-checked') !== 'true'; b.setAttribute('aria-checked', on);
      state.i = state.i.filter(function (x) { return x !== i; }); if (on) state.i.push(i); save();
    });
  });
  var stepBtns = $$('#irh-steps .irh-step');
  /* cooking times inside a step become timers */
  var TRE = /(\d+(?:\.\d+)?)(?:\s*(?:-|–|to)\s*(\d+(?:\.\d+)?))?\s*(minutes?|mins?|hours?|hrs?)\b/gi;
  stepBtns.forEach(function (b, i) {
    var span = b.querySelector('span');
    span.innerHTML = esc(span.textContent).replace(TRE, function (all, a, b2, unit) {
      var sec = Math.round(parseFloat(a) * (/^h/i.test(unit) ? 3600 : 60));
      if (!sec || sec > 12 * 3600) return all;
      return '<span class="irh-timer" role="button" tabindex="0" data-sec="' + sec + '" aria-label="Start a ' + all + ' timer">⏱ ' + all + '</span>';
    });
    if (state.s.indexOf(i) > -1) b.setAttribute('aria-checked', 'true');
    b.addEventListener('click', function (e) {
      if (e.target.closest('.irh-timer')) return;
      var on = b.getAttribute('aria-checked') !== 'true'; b.setAttribute('aria-checked', on);
      state.s = state.s.filter(function (x) { return x !== i; }); if (on) state.s.push(i); save(); progress();
    });
  });
  function progress() {
    var bar = $('#irh-progress'); if (!bar || !stepBtns.length) return;
    bar.style.width = Math.round(100 * state.s.length / stepBtns.length) + '%';
  }
  progress(); scale();

  /* ---------------- 4. timers ---------------- */
  var toast, tick, endAt = 0, ctx;
  function beep() {
    try {
      ctx = ctx || new (window.AudioContext || window.webkitAudioContext)();
      [0, .35, .7].forEach(function (t) {
        var o = ctx.createOscillator(), g = ctx.createGain();
        o.frequency.value = 880; o.connect(g); g.connect(ctx.destination);
        g.gain.setValueAtTime(.0001, ctx.currentTime + t); g.gain.exponentialRampToValueAtTime(.25, ctx.currentTime + t + .02);
        g.gain.exponentialRampToValueAtTime(.0001, ctx.currentTime + t + .28);
        o.start(ctx.currentTime + t); o.stop(ctx.currentTime + t + .3);
      });
    } catch (e) { console.warn('irh: sound', e); }
    if (navigator.vibrate) navigator.vibrate([300, 150, 300]);
  }
  function startTimer(sec, label) {
    if (!toast) {
      toast = document.createElement('div'); toast.className = 'irh-toast'; toast.setAttribute('role', 'status');
      toast.innerHTML = '<span></span><button type="button">Stop</button>';
      toast.querySelector('button').addEventListener('click', stopTimer);
      document.body.appendChild(toast);
    }
    try { ctx = ctx || new (window.AudioContext || window.webkitAudioContext)(); ctx.resume(); } catch (e) { console.warn('irh: sound', e); }
    endAt = Date.now() + sec * 1000;
    clearInterval(tick);
    function draw() {
      var left = Math.max(0, Math.round((endAt - Date.now()) / 1000));
      var mm = Math.floor(left / 60), ss = left % 60;
      toast.querySelector('span').textContent = left ? '⏱ ' + label + ' · ' + (mm >= 60 ? Math.floor(mm / 60) + ':' + String(mm % 60).padStart(2, '0') : mm) + ':' + String(ss).padStart(2, '0') : '⏰ Time is up: ' + label;
      if (!left) { clearInterval(tick); beep(); toast.querySelector('button').textContent = 'Done'; }
    }
    toast.querySelector('button').textContent = 'Stop';
    draw(); tick = setInterval(draw, 1000);
    requestAnimationFrame(function () { toast.classList.add('is-on'); });
  }
  function stopTimer() { clearInterval(tick); if (toast) toast.classList.remove('is-on'); }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.irh-timer'); if (!t) return;
    e.stopPropagation(); startTimer(+t.getAttribute('data-sec'), t.textContent.replace('⏱', '').trim());
  });
  document.addEventListener('keydown', function (e) {
    var t = e.target.closest && e.target.closest('.irh-timer');
    if (t && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); startTimer(+t.getAttribute('data-sec'), t.textContent.replace('⏱', '').trim()); }
  });

  /* ---------------- 5. cook mode: one step at a time, big type, screen stays on ---------------- */
  var cook, at = 0, lock = null;
  function openCook() {
    var steps = $$('#irh-steps .irh-step span:not(.irh-timer)').map(function (s) { return s.innerHTML; });
    if (!steps.length) { var m = $('#irh-method'); if (m) m.scrollIntoView({ behavior: 'smooth' }); return; }
    if (!cook) {
      cook = document.createElement('div'); cook.className = 'irh-cook'; cook.setAttribute('role', 'dialog'); cook.setAttribute('aria-modal', 'true'); cook.setAttribute('aria-label', 'Cook mode');
      cook.innerHTML =
        '<div class="irh-cook__top"><b>' + esc($('h1').textContent) + '</b><button class="irh-cook__ing" type="button">Ingredients</button><button class="irh-cook__x" type="button" aria-label="Close cook mode">Close</button></div>' +
        '<div class="irh-cook__bar"><i></i></div>' +
        '<div class="irh-cook__main"><div class="irh-cook__step"><div class="irh-cook__n"></div><div class="irh-cook__txt irh"></div><p class="irh-cook__wake" style="margin-top:22px"></p></div></div>' +
        '<div class="irh-cook__nav"><button class="irh-cook__prev" type="button">Back</button><button class="irh-cook__next" type="button">Next step</button></div>' +
        '<aside class="irh-cook__drawer" aria-label="Ingredients"><h3>Ingredients</h3><ul></ul></aside>';
      document.body.appendChild(cook);
      cook.querySelector('.irh-cook__x').addEventListener('click', closeCook);
      cook.querySelector('.irh-cook__prev').addEventListener('click', function () { go(at - 1); });
      cook.querySelector('.irh-cook__next').addEventListener('click', function () { if (at >= cookSteps.length - 1) closeCook(); else go(at + 1); });
      cook.querySelector('.irh-cook__ing').addEventListener('click', function () { cook.querySelector('.irh-cook__drawer').classList.toggle('is-open'); });
      var sx = 0;
      cook.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      cook.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 60) go(at + (dx < 0 ? 1 : -1)); }, { passive: true });
    }
    cookSteps = steps;
    cook.querySelector('.irh-cook__drawer ul').innerHTML = $$('#irh-checks .irh-check span').map(function (s) { return '<li>' + s.innerHTML + '</li>'; }).join('');
    cook.hidden = false; document.documentElement.style.overflow = 'hidden';
    var first = stepBtns.findIndex(function (b) { return b.getAttribute('aria-checked') !== 'true'; });
    go(first > -1 ? first : 0);
    cook.querySelector('.irh-cook__next').focus();
    if ('wakeLock' in navigator) navigator.wakeLock.request('screen').then(function (l) { lock = l; cook.querySelector('.irh-cook__wake').textContent = 'Your screen will stay on while you cook.'; }).catch(function (e) { console.warn('irh: wake lock', e); });
    document.addEventListener('keydown', cookKeys);
  }
  var cookSteps = [];
  function go(i) {
    at = Math.max(0, Math.min(cookSteps.length - 1, i));
    cook.querySelector('.irh-cook__n').textContent = 'Step ' + (at + 1) + ' of ' + cookSteps.length;
    cook.querySelector('.irh-cook__txt').innerHTML = cookSteps[at];
    cook.querySelector('.irh-cook__bar i').style.width = Math.round(100 * (at + 1) / cookSteps.length) + '%';
    cook.querySelector('.irh-cook__prev').disabled = at === 0;
    cook.querySelector('.irh-cook__next').textContent = at === cookSteps.length - 1 ? 'Finish' : 'Next step';
    /* the step you leave is marked done on the page too */
    stepBtns.forEach(function (b, k) { if (k < at && b.getAttribute('aria-checked') !== 'true') { b.setAttribute('aria-checked', 'true'); if (state.s.indexOf(k) < 0) state.s.push(k); } });
    save(); progress();
  }
  function cookKeys(e) {
    if (!cook || cook.hidden) return;
    if (e.key === 'ArrowRight' || e.key === ' ') { e.preventDefault(); go(at + 1); }
    else if (e.key === 'ArrowLeft') go(at - 1);
    else if (e.key === 'Escape') closeCook();
  }
  function closeCook() {
    cook.hidden = true; document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', cookKeys);
    if (lock) { lock.release().catch(function () {}); lock = null; }
    var b = $('[data-cook]'); if (b) b.focus();
  }
  $$('[data-cook]').forEach(function (b) { b.addEventListener('click', openCook); });

  /* ---------------- 6. video: nothing from YouTube loads until it is played ---------------- */
  $$('[data-yt]').forEach(function (b) {
    b.addEventListener('click', function () {
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(b.getAttribute('data-yt')) + '?autoplay=1&rel=0';
      f.allow = 'autoplay; encrypted-media; picture-in-picture'; f.allowFullscreen = true; f.title = 'Recipe video';
      b.parentNode.appendChild(f);
    });
  });

  /* ---------------- 7. spices to cart ---------------- */
  function addToCart(ids, btn, doneLabel) {
    var label = btn.innerHTML; btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin',
      body: JSON.stringify({ items: ids.map(function (id) { return { id: +id, quantity: 1 }; }) }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'cart'); return j; }); })
      .then(function () {
        btn.classList.add('is-done'); btn.innerHTML = doneLabel;
        /* the theme's cart (count + panel) listens for these */
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        setTimeout(function () { btn.disabled = false; btn.classList.remove('is-done'); btn.innerHTML = label; }, 2600);
      })
      .catch(function (e) {
        console.warn('irh: add to cart', e);
        btn.innerHTML = 'Try again'; btn.disabled = false;
        setTimeout(function () { btn.innerHTML = label; }, 2600);
      });
  }
  $$('[data-add]').forEach(function (b) { b.addEventListener('click', function () { addToCart([b.getAttribute('data-add')], b, '✓ Added'); }); });
  $$('[data-add-all]').forEach(function (b) { b.addEventListener('click', function () { addToCart(b.getAttribute('data-add-all').split(',').filter(Boolean), b, '✓ All added to your cart'); }); });

  /* ---------------- 8. copy list, share, print, saved ---------------- */
  function flash(btn, txt) { var o = btn.innerHTML; btn.innerHTML = txt; setTimeout(function () { btn.innerHTML = o; }, 2200); }
  $$('[data-copy-list]').forEach(function (b) {
    b.addEventListener('click', function () {
      var left = $$('#irh-checks .irh-check').filter(function (x) { return x.getAttribute('aria-checked') !== 'true'; }).map(function (x) { return '• ' + x.querySelector('span').textContent; });
      var text = $('h1').textContent.trim() + '\n' + left.join('\n') + '\n' + location.href.split('?')[0];
      (navigator.clipboard ? navigator.clipboard.writeText(text) : Promise.reject(new Error('no clipboard')))
        .then(function () { flash(b, '✓ Copied ' + left.length + ' items'); })
        .catch(function (e) { console.warn('irh: copy', e); window.prompt('Copy your shopping list:', text); });
    });
  });
  $$('[data-share]').forEach(function (b) {
    b.addEventListener('click', function () {
      var data = { title: $('h1').textContent.trim(), url: location.href.split('?')[0] };
      if (navigator.share) navigator.share(data).catch(function () {});
      else if (navigator.clipboard) navigator.clipboard.writeText(data.url).then(function () { flash(b, '✓'); });
    });
  });
  $$('[data-print]').forEach(function (b) { b.addEventListener('click', function () { window.print(); }); });
  $$('[data-irh-save]').forEach(function (b) {
    var on = X.saved.has(b.getAttribute('data-irh-save'));
    b.setAttribute('aria-pressed', on); b.setAttribute('aria-label', on ? 'Remove from saved recipes' : 'Save recipe');
  });

  /* ---------------- 9. more like this ---------------- */
  var rel = $('#irh-related');
  if (rel) {
    var load = function () {
      X.load(root.getAttribute('data-feed')).then(function (all) {
        var me = all.filter(function (r) { return r.h === HANDLE; })[0];
        if (!me) return;
        var scored = all.filter(function (r) { return r !== me && r.i; }).map(function (r) {
          var s = 0;
          r.cui.forEach(function (k) { if (me.cui.indexOf(k) > -1) s += 3; });
          r.main.forEach(function (k) { if (me.main.indexOf(k) > -1) s += 2; });
          r.meal.forEach(function (k) { if (me.meal.indexOf(k) > -1) s += 1; });
          r.x.forEach(function (p) { if (me.x.some(function (q) { return q.h === p.h; })) s += 1; });
          return { r: r, s: s + Math.random() * .5 };
        }).filter(function (x) { return x.s >= 2; }).sort(function (a, b) { return b.s - a.s; }).slice(0, 4);
        if (!scored.length) return;
        $('#irh-related-grid').innerHTML = scored.map(function (x) { return X.card(x.r); }).join('');
        rel.hidden = false;
      }).catch(function (e) { console.warn('irh: related', e); });
    };
    /* the library is only fetched when you scroll towards the end of the recipe */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '800px' });
      io.observe($('.irh-share') || $('.irh-shop') || root);   /* rel itself is hidden until filled, and hidden things never intersect */
    } else load();
  }
})();
